import { render, staticRenderFns } from "./WaitListWidget.vue?vue&type=template&id=abe701b6"
import script from "./WaitListWidget.vue?vue&type=script&lang=ts"
export * from "./WaitListWidget.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports